import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=3526bc57&scoped=true&"
import script from "./Stamp.vue?vue&type=script&lang=js&"
export * from "./Stamp.vue?vue&type=script&lang=js&"
import style0 from "./Stamp.vue?vue&type=style&index=0&id=3526bc57&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526bc57",
  null
  
)

export default component.exports